import ko from 'knockout';


// This binding has unwanted effect, it allows embed code to use any binding from at the top of tree
// if you getting unknown content from server, you don't need to use this (use plain htmlBinding);
// ONLY IF: you are owner of embed html and are responsible for that

ko.bindingHandlers.htmlIfNotEmpty = {
	update: (element, valueAccessor) => {
		const htmlContent = ko.unwrap(valueAccessor());

		if (htmlContent) {
			ko.utils.setHtml(element, htmlContent);
		}
	},
};
